import { render, staticRenderFns } from "./DialogPicker.vue?vue&type=template&id=4ab6d25c&scoped=true&"
import script from "./DialogPicker.vue?vue&type=script&lang=js&"
export * from "./DialogPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab6d25c",
  null
  
)

export default component.exports